import React from "react";
import { Tooltip } from "reactstrap";
import type { TooltipProps } from "reactstrap";

export function StyledTooltip({ children, ...props }: TooltipProps) {
    return <Tooltip {...props}>{children}</Tooltip>;
}
